import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { invalidateSystemUserCache, useAssignSystemProjectAdmin } from 'src/api/user'
import { CancelButton } from 'src/components/CancelButton'
import { AppForm, AppFormProps, FormTextField } from 'src/components/FormCore'
import { MainButton } from 'src/components/MainButton'
import { ALREADY_EXISTS } from 'src/constant'
import { useZodForm } from 'src/hooks/zod-form'
import { ShowDialogProps } from 'src/show-dialog'
import { z } from 'zod'

interface ProjectAdminDialogProps extends ShowDialogProps, AppFormProps {}

const ProjectAdminDialog: React.FC<ProjectAdminDialogProps> = ({ pop }) => {
  const { t: translate } = useTranslation('projects')
  const { mutate: assignAdmin } = useAssignSystemProjectAdmin()

  const userSchema = z.object({
    email: z.string().email(),
  })

  const onSubmit = form => {
    assignAdmin(form, {
      onSuccess: () => {
        invalidateSystemUserCache.getSystemProjectAdmins()
        toast.success(translate('successfullyAdded', { ns: 'common-api-message' }))
        pop()
      },
      onError: error => {
        const isAlreadyExist = error['data'] === ALREADY_EXISTS
        toast.error(translate(isAlreadyExist ? 'AlreadyExists' : 'unExpectedError', { ns: 'common-api-message' }))
      },
    })
  }

  const handleMainButtonClick = () => {
    form.handleSubmit(onSubmit)()
  }

  const form = useZodForm(userSchema)
  return (
    <AppForm form={form}>
      <FormTextField name="email" placeholder={translate('email')} />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        <Box display={'flex'} gap={2}>
          <CancelButton onClick={pop} />
          <MainButton key="add-user-button" variant="contained" onClick={handleMainButtonClick}>
            {translate('add-user')}
          </MainButton>
        </Box>
      </Box>
    </AppForm>
  )
}

export default ProjectAdminDialog
